/** Where a kind of document usually lands - ADR-0212 decision 3's table, as presentation.
 *
 * **Expected, not decided.** A bill's scope and category are derived at review from the document,
 * the site's jurisdiction and the fuel or carrier (`evidence/classification.py`), and a person's
 * Accept is the confirmation. This is only what the *kind* implies, so the Processing list can show a
 * plausible Scope and Category column before anyone has opened the bill. It is labelled "expected"
 * wherever it is shown, it is never sent anywhere, and it never stands in for the classification
 * preview on the review screen.
 *
 * A kind that yields no figure (a contract, a certificate, a spreadsheet, anything else) has no
 * entry, and the cell says so with a dash rather than guessing.
 */

export interface ExpectedPlace {
  scope: "1" | "2";
  category: string;
}

const BY_KIND: Readonly<Record<string, ExpectedPlace>> = {
  electricity_bill: { scope: "2", category: "Purchased electricity" },
  gas_bill: { scope: "1", category: "Stationary combustion" },
  // A fuel invoice is mobile or stationary, and which is the person's answer when it does not say.
  fuel_invoice: { scope: "1", category: "Fuel" },
  refrigerant_log: { scope: "1", category: "Fugitive" },
};

export function expectedPlace(kind: string): ExpectedPlace | null {
  return BY_KIND[kind] ?? null;
}
